import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// Define types locally since ngx-charts types are not available
interface ChartData {
  name: string;
  value: number;
  color?: string;
}

interface ChartOption {
  [key: string]: any;
}

interface DonutChartView {
  [key: string]: any;
}

interface PieChartView {
  [key: string]: any;
}
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { RestService } from 'src/app/services/rest-service';
import { AppSettings } from 'src/app/shared/app-settings';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';


export interface DialogData {
  data: Array<any>;
}

@Component({
  selector: 'app-graph-stats',
  templateUrl: './graph-stats.component.html',
  styleUrls: ['./graph-stats.component.css']
,
  standalone: false
})
export class GraphStatsComponent implements OnInit {
  currentuser: any;
  username: string;
  readOnlyUser: boolean = false;
  sitesData: ChartData[] = [];
  allDeviceStatusType: ChartData[] = [];
  donutView: DonutChartView = {
    height: 150,
    width: 150,
    radius: 60,
    donutSize: 20
  }
  chartOptions: ChartOption = {
    showLegend: true,
    legendTitle: '""'
  }

  monitorsAlarmData: ChartData[] = [];
  alarmTypeData: ChartData[] = [];

  alarmClassification: ChartData[] = [];
  monitorsCameraData: ChartData[] = [];
  monitorsOtherData: ChartData[] = [];
  chartAlarmOptions: ChartOption = {
    showLegend: true,
    legendTitle: 'Alarm Total'
  }
  chartCameraOptions: ChartOption = {
    showLegend: true,
    legendTitle: 'Camera Total'
  }
  chartOtherOptions: ChartOption = {
    showLegend: true,
    legendTitle: 'Other devices Total'
  }
  public metricData: any = null;
  public metricDevicedata: any = null;
  public sitesTotalCount: any = null;
  public sitegraph: any = null;
  public sitegraph1: any = null;
  public monitorAlarmGraph: any = null;
  public alarmTypeGraph: any = null;
  public monitorCameraGraph: any = null;
  public monitorOtherGraph: any = null;
  public otherDevicestatus: any = null;
  public monitorOtherGraph1: any = null;
  public monitoringType: any = null;
  public installedCount: any = null;
  public hdSdCount: any = null;
  public monitorsAlarmTotal: any = null;
  public monitorsCameraTotal: any = null;
  public monitorsOthersTotal: any = null;
  public metricStatsData: any = null;
  public proviewStatus: any = null;
  public proviewStatusGraph: any = null;
  public proviewVersion: any = null;
  public proconfigStatus: any = null;
  public proconfigVersion: any = null;
  public environments: any = null;
  public chartsData: any = null;
  public chartsDataAgent: any = null;
  public pieChartType: any = 'doughnut';
  public barChartType: any = 'line';
  public objects: any[] = null;
  public chartColors: any[] = [
    {
      backgroundColor: ["#008000", "#bf1b00", "#f16e02", "#6f87d8"],
      borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF', "#FFFFFF"],
      borderWidth: "3px"
    }
  ];
  public alarmTypeColors: any[] = [
    {
      backgroundColor: ["#008000", "#bf1b00", "#f16e02", "#6f87d8"],
      borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF', "#FFFFFF"],
      borderWidth: "3px"
    }
  ];
  public mTypeColos: any[] = [
    {
      backgroundColor: ["#f16e02", "#008000", "#6f87d8"],
      borderColor: ['#FFFFFF', '#FFFFFF', "#FFFFFF"],
      borderWidth: "3px"
    }
  ];
  public sdhdColors: any[] = [
    {
      backgroundColor: ["#CB4335", "#138D75", "#6f87d8"],
      borderColor: ['#FFFFFF', '#FFFFFF', "#FFFFFF"],
      borderWidth: "3px"
    }
  ];
  public chartColorsAgent: any[] = [
    {
      backgroundColor: [
        // "#FF0000",
        "#007bff",
        "#f16e02",
        "#008000",
        "#ffa500",
        "#00FFFF",
        "#FFFF00",
        "#808000",
        "#00FF00",
        "#008080",
        "#0000FF",
        "#000080",
        "#FF00FF"],
      borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF', "#FFFFFF", '#FFFFFF', '#FFFFFF', '#FFFFFF', "#FFFFFF", '#FFFFFF', '#FFFFFF', '#FFFFFF', "#FFFFFF"],
      borderWidth: "3px"
    }
  ];
  public versionColors: any[] = [

    {
      backgroundColor: [
        "#bf1b00",
        "#007bff",
        "#f16e02",
        "#008000",
        "#ffa500",
        "#00FFFF",
        "#FFFF00",
        "#808000",
        "#00FF00",
        "#008080",
        "#0000FF",
        "#000080",
        "#FF00FF"
      ],
      borderColor: ['#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF'],
      borderWidth: "3px"
    }
  ];
  mobileSites: any = null;
  mSitesCount: any = null;
  fixedSites: any = null;
  fixedCount: any = null;
  public pieChartOptions: any = {
    responsive: true,
    cutoutPercentage: 83,
    layout: {
      padding: 5
    },
    legend: {
      display: true,
      position: 'right',
      align: 'left',
      labels: {
        usePointStyle: true,
        fontSize: 12,
        fontColor: "#fff",
      }
    },
    maintainAspectRatio: true,
    tooltips: {
      mode: 'index',
      intersect: true,
      titleFontSize: 9,
      bodyFontSize: 14,
      callbacks: {
        label: function (tooltipItem, data) {
          let sum = 0;

          var allData = data.datasets[tooltipItem.datasetIndex].data;
          allData.map(data => {
            sum += data;
          });
          var tooltipLabel = data.labels[tooltipItem.index];
          var tooltipData = allData[tooltipItem.index];
          let percentage = (allData[tooltipItem.index] * 100 / sum).toFixed(2) + "%";
          return tooltipLabel + ": " + tooltipData + "(" + percentage + ")";
        }
      }
    },
    plugins: {
      labels: {
        render: 'value'
      }
    },
  };

  public otherPieChartOptions: any = {
    responsive: true,
    cutoutPercentage: 83,
    layout: {
      padding: 5
    },
    legend: {
      display: true,
      position: 'right',
      align: 'left',
      labels: {
        usePointStyle: true,
        fontSize: 8,
        fontColor: "#fff",
      }
    },
    maintainAspectRatio: true,
    tooltips: {
      mode: 'index',
      intersect: true,
      titleFontSize: 9,
      bodyFontSize: 14,
      callbacks: {
        label: function (tooltipItem, data) {
          let sum = 0;

          var allData = data.datasets[tooltipItem.datasetIndex].data;
          allData.map(data => {
            sum += data;
          });
          var tooltipLabel = data.labels[tooltipItem.index];
          var tooltipData = allData[tooltipItem.index];
          // let percentage = (allData[tooltipItem.index] * 100 / sum).toFixed(2) + "%";
          return tooltipLabel + ": " + tooltipData;
        }
      }
    },
    plugins: {
      labels: {
        render: 'value'
      }
    },
  };

  public HidepieChartOptions: any = {
    responsive: true,
    cutoutPercentage: 83,
    layout: {
      padding: 5
    },
    legend: {
      display: true,
      position: 'right',
      align: 'left',
      labels: {
        usePointStyle: true,
        fontSize: 12,
        fontColor: "#fff",
      }
    },
    maintainAspectRatio: true,
    tooltips: {
      mode: 'index',
      intersect: true,
      titleFontSize: 9,
      bodyFontSize: 14,
      callbacks: {
        label: function (tooltipItem, data) {
          let sum = 0;

          var allData = data.datasets[tooltipItem.datasetIndex].data;
          allData.map(data => {
            sum += data;
          });
          var tooltipLabel = data.labels[tooltipItem.index];
          var tooltipData = allData[tooltipItem.index];
          let percentage = (allData[tooltipItem.index] * 100 / sum).toFixed(2) + "%";
          return tooltipLabel + ": " + tooltipData;
        }
      }
    },
    plugins: {
      labels: {
        render: 'value'
      }
    },
  };

  public camModelChartOptions: object;

  solarCount: any = null;
  mCount: any = null;
  fCount: any = null;
  mobilessr: any;
  fixedssr: any;
  totalssr: any;
  upCount: any;
  upCountAlarm: any;
  downCountAlarm: any;
  sdtCountAlarm: any;
  ssrCountAlarm: any;
  totalCountAlarm: any;
  upCountCamera: any;
  downCountCamera: any;
  sdtCountCamera: any;
  ssrCountCamera: any;
  totalCountCamera: any;
  upCountOther: any;
  downCountOther: any;
  sdtCountOther: any;
  ssrCountOther: any;
  totalCountOther: any;
  totalUpcount: any;
  totalDowncount: any;
  totalsdtcount: any;
  alarmUpcount: any;
  data = []
  ssrTotalCount: any;
  totalDeviceCount: number = null;
  isPageError: boolean = true;
  pageLoadMessage: string = "Loading ...";
  api1$: Subscription;
  api2$: Subscription;
  api3$: Subscription;
  api4$: Subscription;
  camModels$: Subscription;
  camModels: any;
  totalSSR: number;
  camMods: any[];
  cameraModelsResponse: any;
  constructor(
    private titleService: Title,
    public authService: AuthenticationService,
    public spinner: SpinnerService,
    private toastr: ToastrService,
    public restService: RestService,
    public dialog: MatDialog
  ) { this.titleService.setTitle("Dashboard"); }

  ngOnInit(): void {
    this.spinner.activate();
    this.currentuser = this.authService.currentUserValue;
    let title = this.titleService.getTitle();
    //let user: any = localStorage.getItem('currentUser');
    if (this.currentuser) {
      this.username = this.currentuser.firstName;
      if (this.currentuser['role'] && this.currentuser['role'].length > 0) {
        for (let i = 0; i < this.currentuser['role'].length; i++) {
          if (this.currentuser['role'][i] === 'view dashboard') {
            this.readOnlyUser = true;
          }
        }
      }
    }
    this.getMetricsDevicedata();
    this.getMetricsData();
    this.getMetricsStats();
    this.getAgentVersion();
    this.getCammodels();
  }

  /**
   * getMetricsData
   */
  public getMetricsData() {
    this.spinner.activate();
    this.api1$ = this.restService.getRequest(AppSettings.METRICS, '').subscribe((response) => {
      if (response == null) {
        this.isPageError = true;
      } else {
        this.isPageError = false;
        this.pageLoadMessage = "";
      }
      this.ssrTotalCount =
        (response.siteStatusByType && response.siteStatusByType[0] ? response.siteStatusByType[0].ssrCount : 0) +
        (response.siteStatusByType && response.siteStatusByType[1] ? response.siteStatusByType[1].ssrCount : 0);
      this.metricData = response;
      this.formatSitesData();
    }, (err) => {
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toastr.error(err.error.message, 'Error');
      } else {
        this.toastr.error('Session Expired Please login again.', 'Error');
      }
    });
  }

  public getMetricsDevicedata() {
    this.spinner.activate();
    this.api2$ = this.restService.getRequest(AppSettings.DEVICEMETRICS, '').subscribe((response) => {
      this.metricDevicedata = response
      if (response == null) {
        this.isPageError = true;
        this.pageLoadMessage = "No data found"
      } else {
        this.isPageError = false;
        this.pageLoadMessage = "";
      }
      for (const prop in response) {
        this.data.push(response[prop])
      }

      for (const count in (this.data[0])) {
        this.totalDeviceCount = this.totalDeviceCount + this.data[0][count].totalCount;
        if (this.data[0][count].type == "Alarm") {
          this.upCountAlarm = this.data[0][count].upCount;
          this.downCountAlarm = this.data[0][count].downCount;
          this.sdtCountAlarm = this.data[0][count].sdtCount;
          this.ssrCountAlarm = this.data[0][count].ssrCount;
          this.totalCountAlarm = this.data[0][count].totalCount;
          this.sdtCountAlarm = this.data[0][count].sdtCount;
        }

        if (this.data[0][count].type == 'Camera') {
          this.upCountCamera = this.data[0][count].upCount;
          this.downCountCamera = this.data[0][count].downCount;
          this.sdtCountCamera = this.data[0][count].sdtCount;
          this.ssrCountCamera = this.data[0][count].ssrCount;
          this.totalCountCamera = this.data[0][count].totalCount;
          this.sdtCountCamera = this.data[0][count].sdtCount;
        }

        if (this.data[0][count].type == 'Other') {
          this.upCountOther = this.data[0][count].upCount;
          this.downCountOther = this.data[0][count].downCount;
          this.sdtCountOther = this.data[0][count].sdtCount;
          this.ssrCountOther = this.data[0][count].ssrCount;
          this.totalCountOther = this.data[0][count].totalCount;
          this.sdtCountOther = this.data[0][count].sdtCount;
        }

        this.totalUpcount = this.upCountAlarm + this.upCountCamera + this.upCountOther;
        this.totalDowncount = this.downCountAlarm + this.downCountCamera + this.downCountOther;
        this.totalsdtcount = this.sdtCountAlarm + this.sdtCountCamera + this.sdtCountOther;
      }

      this.formatSitesData();
      this.spinner.deactivate();
    }, (err) => {
      if (err && err?.error && err?.error?.message && err?.error?.message.length > 0) {
        this.toastr.error(err.error.message, 'Error');
      } else {
        this.toastr.error('Failed to get the data from API, Please try it again.', 'Error');
      }
    })
  }

  /**
   * getMetricsStats
   */
  public getMetricsStats() {
    this.spinner.activate();
    this.api3$ = this.restService.getRequest(AppSettings.METRICSSTATS, '').subscribe((response) => {

      if (response?.proviewStatus !== null) {
        response.proviewStatus.labels[0] = "RUNNING"
        response.proviewStatus.labels[1] = "NOT RUNNING"
      }

      if (response.proconfigStatus !== null) {
        response.proconfigStatus.labels[0] = "RUNNING"
        response.proconfigStatus.labels[1] = "NOT RUNNING"
      }

      if (response.proviewVersion !== null) {
        response.proviewVersion.labels[0] = "NULL"
        response.proconfigVersion.labels[0] = "NULL"
      }

      this.chartsData = response;
      this.formatMetricsStats();
      this.spinner.deactivate();
    }, (err) => {
      this.spinner.deactivate();
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toastr.error(err.error.message, 'Error');
      } else {
        this.toastr.error('Session Expired Please login again.', 'Error');
      }
    });
  }

  /**
   * getCammodels
   */
  public getCammodels() {
    this.spinner.activate();
    this.camModelChartOptions = {...this.otherPieChartOptions};
    this.camModelChartOptions['legend']['display'] = false;
    this.camModels$ = this.restService.getRequest(AppSettings.CAMMODELS, '').subscribe((response) => {
      this.cameraModelsResponse = response
      this.camMods = [];
      for (const property in response) {
        this.camMods.push(
          {
            name: property, value: response[property], color: '#629e51'
          }
        );
      }
      let camModData = {
        data: this.camMods,
        chartType: 'Doughnut',
        id: "1235-5678-9874-kefd",
        legend: "camMods",
        ruleId: "2008561c-4203-4d42-8e1b-4cf8bf5b8c59",
        name: "camMods"
      };
      this.camModels = this.formatGraphGeneric(camModData);
      this.spinner.deactivate();
    }, (err) => {
      this.spinner.deactivate();
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toastr.error(err.error.message, 'Error');
      } else {
        this.toastr.error('Session Expired Please login again.', 'Error');
      }
    });
  }

  formatMetricsStats() {
    if (this.chartsData && this.chartsData.proviewStatus) {
      let proviewStatusStats = [
        { name: "RUNNING", value: this.chartsData['proviewStatus']['data'][0], color: "#629e51" },
        { name: "NOT RUNNING", value: this.chartsData['proviewStatus']['data'][1], color: "#bf1b00" },
      ];
      let proviewStatusStatsData = {
        data: proviewStatusStats,
        chartType: 'Doughnut',
        id: "1235-5678-9874-9635",
        legend: "proviewStatusStats",
        ruleId: "4008561c-4203-4d42-8e1b-4cf8bf5b8c59",
        name: "proviewStatusStats"
      };
      this.proviewStatus = this.formatMetricsGraphData(proviewStatusStatsData);
    }
    if (this.chartsData && this.chartsData.proviewVersion) {
      let proviewStatusStats = [];
      for (let i = 0; i < this.chartsData.proviewVersion['data'].length; i++) {
        proviewStatusStats.push({
          name: this.chartsData.proviewVersion['labels'][i],
          value: this.chartsData.proviewVersion['data'][i],
          color: this.versionColors[i]
        })
      }
      let proviewVersionData = {
        data: proviewStatusStats,
        chartType: 'Doughnut',
        id: "4008561c-4203-4d42-8e1b-8bf5b8c59",
        legend: "proviewStatusStats",
        ruleId: "4008561c-4203-4d42-8e1b-8bf5b8c59",
        name: "proviewVersionStats"
      };
      this.proviewVersion = this.formatGraphGeneric(proviewVersionData);
    }
  }

  private formatSitesData() {
    if (this.metricData || this.metricDevicedata) {
      this.totalSSR = this.ssrCountAlarm + this.ssrCountCamera + this.ssrCountOther
      this.sitesTotalCount = this.metricData?.['siteStatus']?.['totalCount'];

      this.allDeviceStatusType = [
        { name: "upCount", value: this.totalUpcount, color: "#629e51" },
        { name: "downCount", value: (this.totalDowncount - this.totalsdtcount), color: "#bf1b00" },
        { name: "SDT", value: this.totalsdtcount, color: "#f16e02" },
        { name: "SSR", value: this.totalSSR, color: "#6f87d8" }
      ];
      let allDevicesStatus = {
        data: this.allDeviceStatusType,
        chartType: 'Doughnut',
        id: "1234-5678-9874-9638",
        legend: "Sites Data1",
        ruleId: "4008561c-4202-4d42-8e1b-4cf8bf5b8c62",
        name: "Sites Data 1"
      };
      this.sitegraph1 = this.formatAllDeviceTypeCount(allDevicesStatus);
      this.sitesData = [
        { name: "upCount", value: this.metricData?.['siteStatus']?.['upCount'], color: "#629e51" },
        { name: "downCount", value: this.metricData?.['siteStatus']?.['downCount'] - this.ssrTotalCount, color: "#bf1b00" },
        { name: "PSD", value: this.metricData?.['siteStatus']?.['partialCount'], color: "#f16e02" },
        { name: "SSR", value: this.ssrTotalCount, color: "#6f87d8" }
      ];
      let siteData = {
        data: this.sitesData,
        chartType: 'Doughnut',
        id: "1234-5678-9874-9635",
        legend: "Sites Data",
        ruleId: "4008561c-4202-4d42-8e1b-4cf8bf5b8c59",
        name: "Sites Data"
      };
      this.sitegraph = this.formatGraphData(siteData);
      let mType = [
        { name: "TBS", value: this.metricData?.['monitoringService']?.['TBS'], color: "#6f87d8" },
        { name: "Live", value: this.metricData?.['monitoringService']?.['Live'], color: "#629e51" },
        { name: "Client", value: this.metricData?.['monitoringService']?.['Client'], color: "#f16e02" },
      ];
      let mTypeData = {
        data: mType,
        chartType: 'Doughnut',
        id: "1234-1432-9874-9635",
        legend: "Monitoring Type",
        ruleId: "4008561c-4202-4d42-8e1b-4cf8bf5b8c59",
        name: "Monitoring Type"
      };
      this.monitoringType = this.formatGraphGeneric(mTypeData);
      let iType = [
        {
          name: "4-Pre-Removal",
          value: this.metricData?.['installedCount']?.['4-Pre-Removal'] ?
            this.metricData?.['installedCount']?.['4-Pre-Removal'] : 0,
          color: "#629e51"
        },
        {
          name: "2-Installed",
          value: this.metricData?.['installedCount']?.['2-Installed'] ?
            this.metricData?.['installedCount']?.['2-Installed'] : 0,
          color: "#f16e02"
        },
      ];
      let iTypeData = {
        data: iType,
        chartType: 'Doughnut',
        id: "abcd-1432-9874-9635",
        legend: "Installed Count",
        ruleId: "4008561c-4202-4d42-8e1b-4cf8bf5b8c59",
        name: "Installed Count"
      };
      this.installedCount = this.formatGraphGeneric(iTypeData);
      this.monitorsAlarmData = [
        { name: "upCount", value: this.upCountAlarm, color: "#629e51" },
        { name: "downCount", value: (this.downCountAlarm - this.sdtCountAlarm) + this.ssrCountAlarm, color: "#bf1b00" },
        { name: "sdtCount", value: this.sdtCountAlarm, color: "#bf1b00" }
      ];
      let mAlarmData = {
        data: this.monitorsAlarmData,
        chartType: 'Doughnut',
        id: "1234-5678-9874-9636",
        legend: "Sites Data",
        ruleId: "4008561c-4202-4d42-8e1b-4cf8bf5b8c58",
        name: "Monitor Alarm Data"
      };
      this.monitorAlarmGraph = this.formatMonitorGraphData(mAlarmData);
      this.alarmTypeData = [
        { name: "alarm", value: this.metricDevicedata?.['alarmClassification']?.['Alarm'], color: "#629e51" },
        { name: "strobe", value: this.metricDevicedata?.['alarmClassification']?.['Strobe'], color: "#629e51" },
      ];
      let typeAlarmData = {
        data: this.alarmTypeData,
        chartType: 'Doughnut',
        id: "1234-5678-9874-9636",
        legend: "Sites Data",
        ruleId: "4008561c-4202-4d42-8e1b-4cf8bf5b8c58",
        name: "Monitor Alarm Data"
      };
      this.alarmTypeGraph = this.formatAlarmType(typeAlarmData);
      this.monitorsCameraData = [
        { name: "upCount", value: this.upCountCamera, color: "#629e51" },
        { name: "downCount", value: (this.downCountCamera - this.sdtCountCamera) + this.ssrCountCamera, color: "#bf1b00" },
        { name: "sdtCount", value: this.sdtCountCamera, color: "#bf1b00" }
      ];
      let mCamaraData = {
        data: this.monitorsCameraData,
        chartType: 'Doughnut',
        id: "1234-5678-9874-9637",
        legend: "Sites Data",
        ruleId: "4008561c-4202-4d42-8e1b-4cf8bf5b8c57",
        name: "Monitor Camera Data"
      };
      this.monitorCameraGraph = this.formatMonitorGraphData(mCamaraData);
      this.monitorsOtherData = [
        { name: "upCount", value: this.upCountOther, color: "#629e51" },
        { name: "downCount", value: (this.downCountOther - this.sdtCountOther) + this.ssrCountOther, color: "#bf1b00" },
        { name: "sdtCount", value: this.sdtCountOther, color: "#bf1b00" }
      ];
      let mOtherData = {
        data: this.monitorsOtherData,
        chartType: 'Doughnut',
        id: "1234-5678-9874-9634",
        legend: "Sites Data",
        ruleId: "4008561c-4202-4d42-8e1b-4cf8bf5b8c56",
        name: "Monitor Other Data"
      };
      this.monitorOtherGraph = this.formatMonitorGraphData(mOtherData);
      let oDS = [
        { name: "NAS", value: this.metricDevicedata?.['otherDevicestatus']?.['NAS']?.['totalCount'], color: "#629e51" },
        { name: "Access points", value: this.metricDevicedata?.['otherDevicestatus']?.['Access points']?.['totalCount'], color: "#629e51" },
        { name: "Switches", value: this.metricDevicedata?.['otherDevicestatus']?.['Switches']?.['totalCount'], color: "#629e51" },
        { name: "Odroid", value: this.metricDevicedata?.['otherDevicestatus']?.['Odroid']?.['totalCount'], color: "#629e51" },
        { name: "Router", value: this.metricDevicedata?.['otherDevicestatus']?.['Router']?.['totalCount'], color: "#629e51" },
        { name: "Client Bridges", value: this.metricDevicedata?.['otherDevicestatus']?.['Client Bridges']?.['totalCount'], color: "#629e51" }
      ];
      let oDSData = {
        data: oDS,
        chartType: 'Doughnut',
        id: "1234-0258-9874-9634",
        legend: "Sites Data",
        ruleId: "4008561c-4202-4d42-8e1b-1428bf5b8c56",
        name: "Monitor Other Data"
      };
      this.otherDevicestatus = this.formatGraphGeneric(oDSData);
      let mData;
      let fixedData;
      if (
        this.metricData?.['siteStatusByType']?.length > 0) {
        let data = this.metricData?.['siteStatusByType'];
        for (let i = 0; i < data.length; i++) {
          if (data[i]['type'].toLowerCase() === 'mobile') {
            this.mobilessr = data[i]['ssrCount'] == null ? 0 : data[i]['ssrCount']
            mData = [
              { name: "upCount", value: data[i]['upCount'], color: "#629e51" },
              { name: "downCount", value: data[i]['downCount'] - this.mobilessr, color: "#629e51" },
              { name: "partialCount", value: data[i]['partialCount'], color: "#629e51" },
              { name: "SSR", value: this.mobilessr, color: "#6f87d8" }
            ];
            this.mSitesCount = data[i]['total'];
          } else if (data[i]['type'].toLowerCase() === 'fixed') {
            this.fixedssr = data[i]['ssrCount'] == null ? 0 : data[i]['ssrCount']
            fixedData = [
              { name: "upCount", value: data[i]['upCount'], color: "#629e51" },
              { name: "downCount", value: data[i]['downCount'] - this.fixedssr, color: "#629e51" },
              { name: "partialCount", value: data[i]['partialCount'], color: "#629e51" },
              { name: "SSR", value: this.fixedssr, color: "#6f87d8" }
            ];
            this.fixedCount = data[i]['total'];
          }
        }
        this.totalssr = this.mobilessr + this.fixedssr
        this.sitesData = [
          { name: "upCount", value: this.metricData?.['siteStatus']?.['upCount'], color: "#629e51" },
          { name: "downCount", value: this.metricData?.['siteStatus']?.['downCount'], color: "#bf1b00" },
          { name: "PSD", value: this.metricData?.['siteStatus']?.['partialCount'], color: "#f16e02" },
          { name: "SSR", value: this.totalssr, color: "#6f87d8" }
        ];
      }
      this.totalssr = this.mobilessr + this.fixedssr
      this.sitesData = [
        { name: "upCount", value: this.metricData?.['siteStatus']?.['upCount'], color: "#629e51" },
        { name: "downCount", value: this.metricData?.['siteStatus']?.['downCount'], color: "#bf1b00" },
        { name: "PSD", value: this.metricData?.['siteStatus']?.['partialCount'], color: "#f16e02" },
        { name: "SSR", value: this.totalssr, color: "#6f87d8" }
      ];

      let mSites = {
        data: mData,
        chartType: 'Doughnut',
        id: "1234-5678-5674-9634",
        legend: "Sites Data",
        ruleId: "4008561c-4202-4db2-8e1b-4cf8bf5b8c56",
        name: "Mobile Sites"
      };
      this.mobileSites = this.formatMobileSites(mSites);
      let fixedSites = {
        data: fixedData,
        chartType: 'Doughnut',
        id: "1234-5678-5674-1634",
        legend: "Sites Data",
        ruleId: "4008561c-4202-4db2-8e1b-4cfddf5b8c56",
        name: "Mobile Sites"
      };
      this.fixedSites = this.formatFixedSites(fixedSites);
    }
  }

  formatFixedSites(resData?: any) {
    let formatData: any;
    formatData = {
      insightId: resData.id,
      insightData: {
        chartType: resData.chartType,
        data: [
          [
            resData.data[0]['value'],
            resData.data[1]['value'],
            resData.data[2]['value'],
            resData.data[3]['value']
          ]
        ],
        backgroundColor: [
          resData.data[0]['color'],
          resData.data[1]['color'],
          resData.data[2]['color'],
          resData.data[3]['color']
        ],
        executionTime: new Date(),
        labels: [
          "UP COUNT",
          "DOWN COUNT",
          "PSD",
          "SSR"
        ],
        legends: [
          resData.legend
        ],
        ruleDescription: "",
        ruleDisplayName: "",
        ruleId: resData.ruleId,
        ruleName: resData.name
      },
      configOptions: {
        border: "",
        columnCount: "",
        loading: false,
        rowHeight: "18rem",
        showCalendar: false,
        showLabels: true,
        zoomOption: false,
        cols: 1,
        rows: 1,
        reduceBarGraphLabels: false,
        mergeSummary: true,
        mergeSummaryData: null
      }
    }
    return formatData;
  }

  formatMobileSites(resData?: any) {
    let formatData: any;
    formatData = {
      insightId: resData.id,
      insightData: {
        chartType: resData.chartType,
        data: [
          [
            resData?.data[0]['value'],
            resData?.data[1]['value'],
            resData?.data[2]['value'],
            resData?.data[3]['value']
          ]
        ],
        backgroundColor: [
          resData.data[0]['color'],
          resData.data[1]['color'],
          resData.data[2]['color'],
          resData.data[3]['color']
        ],
        executionTime: new Date(),
        labels: [
          "UP COUNT",
          "DOWN COUNT",
          "PSD",
          "SSR"
        ],
        legends: [
          resData.legend
        ],
        ruleDescription: "",
        ruleDisplayName: "",
        ruleId: resData.ruleId,
        ruleName: resData.name
      },
      configOptions: {
        border: "",
        columnCount: "",
        loading: false,
        rowHeight: "18rem",
        showCalendar: false,
        showLabels: true,
        zoomOption: false,
        cols: 1,
        rows: 1,
        reduceBarGraphLabels: false,
        mergeSummary: true,
        mergeSummaryData: null
      }
    }
    return formatData;
  }

  formatGraphData(resData?: any) {
    let formatData: any;
    formatData = {
      insightId: resData.id,
      insightData: {
        chartType: resData.chartType,
        data: [
          [
            resData.data[0]['value'],
            resData.data[1]['value'],
            resData.data[2]['value'],
            resData.data[3]['value']
          ]
        ],
        backgroundColor: [
          resData.data[0]['color'],
          resData.data[1]['color'],
          resData.data[2]['color'],
          resData.data[3]['color']
        ],
        executionTime: new Date(),
        labels: [
          "UP COUNT",
          "DOWN COUNT",
          "PSD",
          "SSR"
        ],
        legends: [
          resData.legend
        ],
        ruleDescription: "",
        ruleDisplayName: "",
        ruleId: resData.ruleId,
        ruleName: resData.name
      },
      configOptions: {
        border: "",
        columnCount: "",
        loading: false,
        rowHeight: "18rem",
        showCalendar: false,
        showLabels: true,
        zoomOption: false,
        cols: 1,
        rows: 1,
        reduceBarGraphLabels: false,
        mergeSummary: true,
        mergeSummaryData: null
      }
    }
    return formatData;
  }

  formatAllDeviceTypeCount(resData?: any) {
    let formatData: any;
    formatData = {
      insightId: resData.id,
      insightData: {
        chartType: resData.chartType,
        data: [
          [
            resData.data[0]['value'],
            resData.data[1]['value'],
            resData.data[2]['value'],
            resData.data[3]['value']
          ]
        ],
        backgroundColor: [
          resData.data[0]['color'],
          resData.data[1]['color'],
          resData.data[2]['color'],
          resData.data[3]['color']
        ],
        executionTime: new Date(),
        labels: [
          "UP COUNT",
          "DOWN COUNT",
          "SDT",
          "SSR"
        ],
        legends: [
          resData.legend
        ],
        ruleDescription: "",
        ruleDisplayName: "",
        ruleId: resData.ruleId,
        ruleName: resData.name
      },
      configOptions: {
        border: "",
        columnCount: "",
        loading: false,
        rowHeight: "18rem",
        showCalendar: false,
        showLabels: true,
        zoomOption: false,
        cols: 1,
        rows: 1,
        reduceBarGraphLabels: false,
        mergeSummary: true,
        mergeSummaryData: null
      }
    }
    return formatData;
  }

  formatMonitorGraphData(resData?: any) {
    let formatData: any;
    formatData = {
      insightId: resData.id,
      insightData: {
        chartType: resData.chartType,
        data: [
          [
            resData.data[0]['value'],
            resData.data[1]['value'],
            resData.data[2]['value']
          ]
        ],
        executionTime: new Date(),
        labels: [
          "UP COUNT",
          "DOWN COUNT",
          "SDT COUNT"
        ],
        legends: [
          resData.legend
        ],
        ruleDescription: "",
        ruleDisplayName: "",
        ruleId: resData.ruleId,
        ruleName: resData.name
      },
      configOptions: {
        border: "",
        columnCount: "",
        loading: false,
        rowHeight: "18rem",
        showCalendar: false,
        showLabels: true,
        zoomOption: false,
        cols: 1,
        rows: 1,
        reduceBarGraphLabels: false,
        mergeSummary: true,
        mergeSummaryData: null
      }
    }
    return formatData;
  }

  formatAlarmType(resData?: any) {
    let formatData: any;
    formatData = {
      insightId: resData.id,
      insightData: {
        chartType: resData.chartType,
        data: [
          [
            resData.data[0]['value'],
            resData.data[1]['value'],
            // resData.data[2]['value']
          ]
        ],
        executionTime: new Date(),
        labels: [
          "ALARM",
          "STROBE",
          // "SDT COUNT"
        ],
        legends: [
          resData.legend
        ],
        ruleDescription: "",
        ruleDisplayName: "",
        ruleId: resData.ruleId,
        ruleName: resData.name
      },
      configOptions: {
        border: "",
        columnCount: "",
        loading: false,
        rowHeight: "18rem",
        showCalendar: false,
        showLabels: true,
        zoomOption: false,
        cols: 1,
        rows: 1,
        reduceBarGraphLabels: false,
        mergeSummary: true,
        mergeSummaryData: null
      }
    }
    return formatData;
  }
  formatMetricsGraphData(resData?: any) {
    let formatData: any;
    formatData = {
      insightId: resData.id,
      insightData: {
        chartType: resData.chartType,
        data: [
          [
            resData.data[0]['value'],
            resData.data[1]['value']
          ]
        ],
        executionTime: new Date(),
        labels: [
          "RUNNING",
          "NOT RUNNING"
        ],
        legends: [
          resData.legend
        ],
        ruleDescription: "",
        ruleDisplayName: "",
        ruleId: resData.ruleId,
        ruleName: resData.name
      },
      configOptions: {
        border: "",
        columnCount: "",
        loading: false,
        rowHeight: "18rem",
        showCalendar: false,
        showLabels: true,
        zoomOption: false,
        cols: 1,
        rows: 1,
        reduceBarGraphLabels: false,
        mergeSummary: true,
        mergeSummaryData: null
      }
    }
    return formatData;
  }

  formatGraphGeneric(resData?: any) {
    let formatData: any;
    let data = [];
    let lebels = [];
    for (let i = 0; i < resData.data.length; i++) {
      data.push(resData.data[i]['value']);
      lebels.push(resData.data[i]['name']);
    }
    formatData = {
      insightId: resData.id,
      insightData: {
        chartType: resData.chartType,
        data: [
          data
        ],
        executionTime: new Date(),
        labels: lebels,
        legends: [
          resData.legend
        ],
        ruleDescription: "",
        ruleDisplayName: "",
        ruleId: resData.ruleId,
        ruleName: resData.name
      },
      configOptions: {
        border: "",
        columnCount: "",
        loading: false,
        rowHeight: "18rem",
        showCalendar: false,
        showLabels: true,
        zoomOption: false,
        cols: 1,
        rows: 1,
        reduceBarGraphLabels: false,
        mergeSummary: true,
        mergeSummaryData: null
      }
    }
    return formatData;
  }

  public getAgentVersion() {
    this.spinner.activate();
    this.api4$ = this.restService.getRequest(AppSettings.AGENT_VERSION, '').subscribe((response) => {
      if (response == null || response.data == null) {
        this.isPageError = true;
      } else {
        this.isPageError = false;
        this.pageLoadMessage = "";
      }
      if (response.hasOwnProperty('data') && response.data !== null) {
        var dataValue = response.data.proDeviceAgentInfos;
        let version = getUniqueDataCount({ objArr: dataValue, propName: ["version"] })
        // let y = getUniqueDataCount({ objArr: dataValue, propName: ['environment'] }) ;
        var agentVer = Object.values(version)
        var agentVerLabels = Object.keys(version)
        var agentDetail = response.data
        response = ({ agentVer, agentDetail, agentVerLabels })
        function getUniqueDataCount({ objArr, propName }: { objArr; propName; }): {} {
          var data = [];
          if (Array.isArray(propName)) {
            propName.forEach(prop => {
              objArr.forEach((d) => {
                if (d[prop]) {
                  data.push(d[prop]);
                }
              });
            });
          } else {
            objArr.forEach(function (d, index) {
              if (d[propName]) {
                data.push(d[propName]);
              }
            });
          }
          var uniqueList = [...new Set(data)];
          var dataSet = {};
          for (var i = 0; i < uniqueList.length; i++) {
            dataSet[uniqueList[i]] = data.filter(x => x == uniqueList[i]).length;
          }
          return dataSet;
        }
        this.chartsDataAgent = response;
        this.spinner.deactivate();
      } else {
        this.spinner.deactivate();
        this.toastr.error('Agent version data not found');
      }
    }, (err) => {
      this.spinner.deactivate();
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toastr.error(err.error.message, 'Error');
      } else {
        this.toastr.error('Session Expired Please login again.', 'Error');
      }
    });
  }

  openDialog(info: any) {
    const dialogRef = this.dialog.open(DetailsDialog, {
      width: '390px !important',
      data: info
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  opencameraDialog(){
    const dialogRef = this.dialog.open(CamdetailsDialog,{
      width: '390px !important',
      data: this.cameraModelsResponse
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  ngOnDestroy() {
    if(this.api1$){
    this.api1$.unsubscribe();
    }
    if(this.api2$){
    this.api2$.unsubscribe();
    }
    if(this.api3$){
    this.api3$.unsubscribe();
    }
    if(this.api4$){
    this.api4$.unsubscribe();
    }
    if(this.camModels$){
    this.camModels$.unsubscribe();
    }
  }
}

@Component({
  selector: 'app-details-stats',
  templateUrl: 'detail.html',
  styleUrls: ['./graph-stats.component.css']
,
  standalone: false
})

export class DetailsDialog {
  constructor(
    public dialogRef: MatDialogRef<DetailsDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public restService: RestService
  ) {
  }
  public close() {
    this.dialogRef.close();
  }

  /**
 * downloadExcel
 */
  public downloadExcel() {
    if (this.data) {
      this.downloadData(this.data, 'Details');
    }
  }

  downloadData(data, filename) {
    let csvData = this.ConvertToCSV(data, ['potentialId', 'vpnIp', 'environment', 'version']);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  ConvertToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = "Potential Id,VPN IP,Environment,Version";

    // for (let index in headerList) {
    //   row += headerList[index] + ',';
    // }
    // row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = '';
      for (let index in headerList) {
        let head = headerList[index];
        line += ((typeof (array[i][head]) === 'string') ? array[i][head].replace(',', ' ') : array[i][head]) + ',';
      }
      str += line + '\r\n';
    }
    return str;
  }
}


@Component({
  selector: 'app-details-stats',
  templateUrl: 'camera-models.html',
  styleUrls: ['./graph-stats.component.css']
,
  standalone: false
})

export class CamdetailsDialog {
  camNames: any;
  camCount: any;
  constructor(
    public dialogRef: MatDialogRef<CamdetailsDialog>,
    @Inject(MAT_DIALOG_DATA) public camdata: any,
    public restService: RestService
  ) {
    this.camNames = Object.keys(camdata)
    this.camCount = Object.values(camdata)
  }
  public close() {
    this.dialogRef.close();
  }

  downloadCsv(camdata) {
    const camNames = Object.keys(camdata);
    const camCount = Object.values(camdata);
  
    const csvRows = [
      ['Camera Model', 'Count'],
      ...camNames.map((name, i) => [name, camCount[i]])
    ];
  
    const csvData = csvRows.map(row => row.join(',')).join('\n');
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Camera data.csv';
    a.click();
    URL.revokeObjectURL(url);
  }
}
